module.exports = __webpack_public_path__ + "img/applications.1385c214.svg";